import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';
import {
  connect,
} from 'react-redux';
import {
  bindActionCreators,
} from 'redux';
import React from 'react';
import Welcome from '../Welcome/index';
import {
  loadApp,
} from '../../redux/actions/index';

class App extends React.Component {
  componentWillMount() {
    this.props.loadApp();
  }
  render() {
    console.log(this.props.loaded);
    return (
      <Router>
        <div>
          <Route path="/" component={Welcome} />
        </div>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  return {
    loaded: state.app.loaded,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadApp: bindActionCreators(loadApp.request, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/views/App/index.js